import React from 'react';
import PropTypes from 'prop-types';
import lodash from 'lodash';
import { DropdownItem } from 'reactstrap';
import Icon from '../common/containers/icon';
const MenuDropdownItem = ({
  className: _className = '',
  glyph: _glyph = '',
  title,
  href,
  onClick: _onClick = undefined
}) => /*#__PURE__*/React.createElement(DropdownItem, {
  className: _className.length > 0 ? _className : lodash.kebabCase(`mdi-${title}`),
  href: href,
  onClick: _onClick
}, _glyph.length > 0 ? /*#__PURE__*/React.createElement(Icon, {
  glyph: _glyph,
  style: {
    marginRight: '10px'
  }
}) : null, title);
MenuDropdownItem.propTypes = {
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  glyph: PropTypes.string,
  href: PropTypes.string.isRequired,
  onClick: PropTypes.func
};
export default MenuDropdownItem;